import { resToImage } from "services/images";

import { Page } from "./types";

export const resToPage = (res: any): Page => {
  return {
    id: res.id,
    title: res.title ? res.title : "",
    metaDescription: res.metaDescription ?? "",
    metaTitle: res.metaTitle ?? "",
    slug: res.slug ?? "",
    image: res.image ? resToImage(res.image) : null,
    descriptionText: res.descriptionText ?? "",
    createdAt: res.createdAt ? new Date(res.createdAt) : new Date(),
    updatedAt: res.updatedAt ? new Date(res.updatedAt) : new Date(),
  };
};

export const pageToBody = (data: Page): any => ({
  title: data.title,
  metaDescription: data.metaDescription,
  metaTitle: data.metaTitle,
  slug: data.slug,
  imageId: data.image?.id,
  descriptionText: data.descriptionText,
});
